module.exports = __webpack_public_path__ + "static/img/nr1-19.10f399d.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/nr1-19.png
// module id = 700
// module chunks = 0